import {InvoicePaymentReleaseApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";

export default class InvoicePaymentReleaseData {

	constructor(public readonly hiberFee: number,
		public readonly hiberPartsMarginShare: number,
		public readonly hiberPaymentReleased: boolean,
		public readonly hiberPaymentActive: boolean,
		public readonly hiberPaymentSubtotal: number,
		public readonly hiberPaymentTotal: number,
		public readonly hiberPaymentVat: Option<number>,
		public readonly hiberLoanForPartner: Option<number>,
		public readonly installerEarnings: number,
		public readonly partnerPartsMarginShare: Option<number>,
		public readonly partnerPaymentActive: boolean,
		public readonly partnerPaymentReleased: boolean,
		public readonly partnerPaymentSubtotal: number,
		public readonly partnerPaymentTotal: number,
		public readonly partnerPaymentVat: Option<number>,
		public readonly rewardsDiscount: Option<number>,
		public readonly cardFee: Option<number>,
		public readonly selfSourcedItemsSubtotal: number) {}

	static fromJson(json: InvoicePaymentReleaseApiDto): InvoicePaymentReleaseData {
		return new InvoicePaymentReleaseData(json.hiberFee, json.hiberPartsMarginShare, json.hiberPaymentReleased,
			json.hiberPaymentActive, json.hiberPaymentSubtotal, json.hiberPaymentTotal, option(json.hiberPaymentVat),
			option(json.hiberLoanForPartner), json.installerEarnings, option(json.partnerPartsMarginShare),
			json.partnerPaymentActive, json.partnerPaymentReleased, json.partnerPaymentSubtotal, json.partnerPaymentTotal,
			option(json.partnerPaymentVat), option(json.rewardsDiscount), option(json.cardFee), json.selfSourcedItemsSubtotal);
	}
}
